module.exports = __webpack_public_path__ + "static/media/5860.cc23275f.jpg";